import React, { useEffect, useRef } from 'react';
import { ReactComponent as InfoIcon } from '../../assets/img/info.svg';
import { useSwipeGesture } from '../../hooks/useSwipeGesture';
import '../../assets/styles/estimated-fare.sass';

const NewFareEstimate = props => {
  const { toggleFare, togglePopup, updateDestination, newFare } = props;
  const fare = newFare ? (newFare / 100).toFixed(2) : null;

  const newFareContainer = useRef(null);
  const [setIsZoneOpened, setSwipedZone] = useSwipeGesture({
    zone: newFareContainer?.current,
    exceptionZoneList: {
      custom: ['toggle-btn'],
      click: ['open-fare-popup', 'cancel-changes-btn', 'apply-changes-btn'],
    },
    toggleHandler: toggleFare,
  });

  useEffect(() => {
    if (!newFareContainer?.current) return;
    setSwipedZone(newFareContainer?.current);
  }, [newFareContainer?.current, setSwipedZone]);

  const openFarePopup = () => {
    togglePopup(true, 'fare');
  };

  return (
    <div className="overlay">
      <div ref={newFareContainer} className="new-fare-container">
        <div className="toggle-btn" onClick={toggleFare} />
        <div className="fare-value-container">
          <div className="fare-label">New Fare: </div>
          <div className="fare-value">
            ${fare}
            <div className="info-btn open-fare-popup" onClick={openFarePopup}>
              <InfoIcon />
            </div>
          </div>
        </div>
        <div className="fare-message">Based on your updated destination</div>
        <div className="btn-handler">
          <button className="cancel-changes-btn btn btn-default" onClick={toggleFare}>
            Cancel Change
          </button>
          <button className="apply-changes-btn btn btn-primary" onClick={updateDestination}>
            Ok
          </button>
        </div>
      </div>
    </div>
  );
};

export default NewFareEstimate;
